import React from 'react';
import BlankPage from '../../../components/BlankPage';

const Archive = () => {
  return (
    <BlankPage 
      title="Archive" 
      description="Access and manage archived employees, documents, and other historical records." 
    />
  );
};

export default Archive; 